export const CONTEXT_MENU_CHANGE_TYPE = 'CONTEXT_MENU_CHANGE_TYPE';
export const CONTEXT_MENU_HIDE = 'CONTEXT_MENU_HIDE';
export const CONSULTS_ACTIVE_CONVERSATION = 'CONSULTS_ACTIVE_CONVERSATION';
export const CONSULT_RETRIEVE_SUCCEED = 'CONSULT_RETRIEVE_SUCCEED';
export const CONTEXT_BUBBLE_MENU_CHANGE_TYPE = 'CONTEXT_BUBBLE_MENU_CHANGE_TYPE';
export const CONTEXT_BUBBLE_MENU_HIDE = 'CONTEXT_BUBBLE_MENU_HIDE';
export const CLOSE_ALL_BUBBLE_MENU = 'CLOSE_ALL_BUBBLE_MENU';

export const CHECK_ELIGIBLE_ISSUE_MC_REQUEST = 'CHECK_ELIGIBLE_ISSUE_MC_REQUEST';
export const CHECK_ELIGIBLE_ISSUE_MC_SUCCEED = 'CHECK_ELIGIBLE_ISSUE_MC_SUCCEED';
export const CHECK_ELIGIBLE_ISSUE_MC_FAILED = 'CHECK_ELIGIBLE_ISSUE_MC_FAILED';
